import { ITreeviewNhomLopFocusedValue } from "../../../components-data/treeview-nhom-lop/TreeviewNhomLop";
import { IKeHoachLopSaveRequest } from "../../../model/request/ke-hoach/IKeHoachLopSaveRequest";
import { IKeHoachLopSelectRequest } from "../../../model/request/ke-hoach/IKeHoachLopSelectRequest";
import { IKeHoachLop } from "../../../model/respone/ke-hoach/IKeHoachLop";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachLopActionsObj = {
    CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewNhomLopFocusedValue,

    LOAD_START: {} as IKeHoachLopSelectRequest,
    LOAD_SUCCESS: {} as IKeHoachLop[],
    LOAD_ERRR: "",

    SAVE_START: {} as IKeHoachLopSaveRequest,
    SAVE_SUCCESS: {} as IKeHoachLop[],
    SAVE_ERRR: "",

    DELETE_START: {} as number[],
    DELETE_SUCCESS: {} as number[],
    DELETE_ERRR: "",

    CHANGE_DISPLAY_MODE: {} as "view" | "edit"
};
export const eKeHoachLopActionIds = generateActionTypeIds(
    eKeHoachLopActionsObj,
    "KE_HOACH_LOP"
);
export type IKeHoachLopActionTypes = IGenericActionType<
    typeof eKeHoachLopActionsObj,
    "KE_HOACH_LOP"
>;
